<template>
  <div class="outer">
    <div class="inner">
      <nuxt />
    </div>
    <critical-error-modal />
  </div>
</template>

<script>
import CriticalErrorModal from '~/components/critical-error-modal'

export default {
  components: {
    CriticalErrorModal
  }
}
</script>

<style lang="scss" scoped>
@import "~assets/styles/sso";

.outer {
  display: flex;
  min-width: 100vw;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  background: $sso-black;

  @include breakpoint(medium) {
    width: 100vw;
    height: 100vh;
    @include transition-fast;
  }

  .inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 100vh;

    @include breakpoint(medium) {
      flex-grow: 0;
      max-width: $bp-large;
      max-height: 70vh;
    }
  }
}
</style>
